@if (lorenzFormControl && lorenzFormGroup) {

<div
	class="outer-wrapper"
	[formGroup]="lorenzFormGroup">
	<div class="control-wrapper">
		<div
			class="control document-upload"
			[ngClass]="{
				readonly: isBlocked,
				'backend-documents-app': isBackendDocumentsApp,
				faulty: lorenzFormControl.isFaulty(),
				'missing-required': lorenzFormControl.isMissingRequiredValue(),
				'ng-untouched': !lorenzFormControl.touched,
				'ng-touched': lorenzFormControl.touched,
				'ng-valid': lorenzFormControl.valid && !needsRevalidation,
				'ng-invalid': lorenzFormControl.invalid || needsRevalidation
			}">
			@if (showPartnerDeferredSaveHint) {
			<div class="document-hint info compact">Upload erfolgt beim Speichern oder beim Absenden an Lorenz Messe.</div>
			} @if (documentCards.length === 0 && visibleExpiredDocuments.length === 0 && !hasPendingUpload) {
			<div class="document-hint">
				@if (isLoading) {
				<span>Dokumente werden geladen...</span>
				} @else {
				<span>Noch kein Dokument vorhanden.</span>
				}
			</div>
			} @if (documentCards.length > 0) {
			<div class="document-list">
				@for (doc of documentCards; track doc.id) {
				<ng-container *ngTemplateOutlet="documentCardTemplate; context: { $implicit: doc, expired: false, showDetails: true }"></ng-container>
				}
			</div>
			} @if (showContractDocumentSelection) {
			<div class="contract-document-selection">
				<label
					class="contract-document-selection-label"
					for="contract-document-selection-{{ documentType }}">
					Gültiges Dokument aus dem Dokumentenmanagement verwenden
				</label>
				<select
					class="contract-document-selection-control"
					[id]="'contract-document-selection-' + documentType"
					[formControl]="contractDocumentSelectionControl"
					[disabled]="isBlocked || isSelectingContractDocument"
					(change)="selectContractDocumentFromDropdown()">
					<option [ngValue]="null">Bitte Dokument auswählen</option>
					@for (doc of selectableContractDocuments; track doc.id) {
					<option [ngValue]="doc.id">
						{{ formatDisplayFileName(doc.original_name) }}@if (doc.expires_at) { – gültig bis {{ formatDateForDisplay(doc.expires_at) }}}
					</option>
					}
				</select>
				<div class="document-hint compact">Es werden nur geprüfte Dokumente angezeigt, die für den gesamten Vertragszeitraum gültig sind.</div>
			</div>
			} @if (restoreCandidate; as hiddenDoc) {
			<div class="restore-row">
				<div class="document-meta">Verstecktes Dokument: {{ formatDisplayFileName(hiddenDoc.original_name) }}</div>
				<button
					mat-flat-button
					type="button"
					class="mat-secondary document-action-button"
					[disabled]="!canRestoreDocument"
					(click)="restoreDocument()">
					<span>Wiederherstellen</span>
				</button>
			</div>
			} @if (hasPendingUpload && displayDocuments.length === 0) {
			<div class="document-list">
				<div class="document-item pending">
					<div class="document-info">
						<div class="document-name">{{ pendingFileName }}</div>
						@if (hasPendingMultiPageUpload && pendingMultiPageHint) {
						<div class="document-meta">{{ pendingMultiPageHint }}</div>
						} @if (showExpiryMeta && deferUpload && pendingExpiresAt) {
						<div class="document-meta">Ablaufdatum: {{ formatDateForDisplay(pendingExpiresAt) }}</div>
						} @if (deferUpload) {
						<div class="document-meta">Zum Upload vorgemerkt. Upload erfolgt beim Speichern oder Absenden.</div>
						} @else {
						<div class="document-meta">Erfolgreich hochgeladen.</div>
						}
					</div>
					<div class="document-actions">
						@if (allowPreview && !hasPendingMultiPageUpload) { @if (showTextActionButtons) {
						<button
							mat-flat-button
							class="mat-preview document-action-button"
							type="button"
							(click)="previewPendingDocument()">
							<span>Vorschau</span>
						</button>
						} @else {
						<button
							mat-flat-button
							class="mat-preview document-action-icon-button"
							type="button"
							matTooltip="Vorschau"
							aria-label="Vorschau"
							(click)="previewPendingDocument()">
							<mat-icon>visibility</mat-icon>
						</button>
						} } @if (showTextActionButtons) {
						<button
							mat-flat-button
							class="mat-development document-action-button"
							type="button"
							[disabled]="isBlocked"
							(click)="clearPendingDocument()">
							<span>Löschen</span>
						</button>
						} @else {
						<button
							mat-flat-button
							class="mat-development document-action-icon-button"
							type="button"
							matTooltip="Löschen"
							aria-label="Löschen"
							[disabled]="isBlocked"
							(click)="clearPendingDocument()">
							<mat-icon>delete</mat-icon>
						</button>
						}
					</div>
				</div>
			</div>
			} @if (visibleExpiredDocuments.length > 0) { @if (isBackendDocumentsApp) {
			<details class="document-expired-group">
				<summary class="document-expired-summary">
					<span class="document-expired-summary-main">
						<span
							class="document-expired-summary-icon"
							aria-hidden="true">
							<mat-icon>chevron_right</mat-icon>
						</span>
						<span>Ältere / abgelaufene Dokumente</span>
					</span>
					<span class="document-expired-count">{{ visibleExpiredDocuments.length }}</span>
				</summary>
				<div class="document-expired">
					@for (doc of visibleExpiredDocuments; track doc.id) {
					<ng-container *ngTemplateOutlet="documentCardTemplate; context: { $implicit: doc, expired: true, showDetails: false }"></ng-container>
					}
				</div>
			</details>
			} @else {
			<div class="document-expired">
				<div class="expired-title">Abgelaufene Dokumente</div>
				@for (doc of visibleExpiredDocuments; track doc.id) {
				<ng-container *ngTemplateOutlet="documentCardTemplate; context: { $implicit: doc, expired: true, showDetails: false }"></ng-container>
				}
			</div>
			} } @if (partnerDocumentRenewalLink; as renewalLink) {
			<div class="document-hint info">
				<a
					[href]="renewalLink.url"
					target="_blank"
					rel="noopener noreferrer">{{ renewalLink.text }}</a>
			</div>
			} @if (allowUpload) { @if (hasFrozenReviewedDocument && (!allowSignedCategoryBManagement || isHealthCertificateType)) {
			<div class="document-hint">Geprüftes Dokument in eingefrorenem Vertrag kann nicht ersetzt werden.</div>
			} @else { @if (hasDocumentBlockingUpload) {
			<div class="document-hint">
				@if (isBackendContractEditApp && hasPendingPartnerReplacement) { Ersatzdokument vorhanden. Über „Ersatz im Vertrag übernehmen“ wird es ungeprüft in den Vertrag übernommen. } @else { @if (isHealthCertificateType) { @if (hasHealthCertificateRefreshAfterContractStart) { Auffrischung hochgeladen. Nach dem Absenden an uns prüfen wir die Auffrischung. Bis dahin bleibt das Gesundheitszeugnis für den Vertragsstart als ungültig markiert. } @else { Gesundheitszeugnis vorhanden. Eine Verlängerung erfolgt über die Auffrischung. } } @else { Dokument vorhanden. Vor neuem Upload bitte zuerst löschen. } }
			</div>
			} @else {
			<div class="upload-row">
				<input
					#fileInput
					type="file"
					class="file-input"
					[attr.accept]="acceptTypes"
					[attr.disabled]="isBlocked || isUploading || !hasCredentials || hasDocumentBlockingUpload || hasFrozenReviewedDocument ? true : null"
					(change)="onFileSelected($event)" />

				<button
					mat-flat-button
					type="button"
					class="mat-secondary upload-button"
					[disabled]="isBlocked || isUploading || !hasCredentials || hasDocumentBlockingUpload || hasFrozenReviewedDocument"
					(click)="fileInput.click()">
					<span>Datei auswählen</span>
				</button>
				<div class="upload-info compact">
					<div>{{ allowedUploadFormatsLabel }} • max. {{ maxTotalUploadSizeLabel }} insgesamt</div>
				</div>
				@if (queuedFileName) {
				<div class="queued-file-hint">Datei ausgewählt: {{ queuedFileName }}</div>
				} @if (isMultiPageEnabled && hasBufferedMultiPageFiles) { @if (bufferedMultiPageFileNames) {
				<div class="queued-file-hint">Im Stapel: {{ bufferedMultiPageFileNames }}</div>
				}
				<div class="queued-file-hint">{{ bufferedMultiPageCount }} Dateien ausgewählt.</div>
				} @if (showExpiryInput) {
				<div
					class="expiry-input"
					[ngClass]="{
						'partner-required-highlight': shouldHighlightPartnerExpiryInput,
						'contract-start-invalid': isSelectedExpiryInvalidForContractStart
					}">
					<label class="expiry-label">Ablaufdatum@if (expiryRequired) {<span class="required">*</span>}</label>
					<input
						class="expiry-control"
						type="date"
						[formControl]="expiresAtControl"
						[attr.required]="expiryRequired ? true : null"
						[attr.disabled]="isBlocked || hasDocumentBlockingUpload || hasFrozenReviewedDocument || (!hasQueuedFile && !(isMultiPageEnabled && hasBufferedMultiPageFiles)) ? true : null" />
					@if (shouldHighlightPartnerExpiryInput) {
					<div class="expiry-hint">Bitte jetzt das Ablaufdatum eingeben. Danach kannst du das Dokument vormerken.</div>
					} @if (isSelectedExpiryInvalidForContractStart) {
					<div class="expiry-hint expiry-warning">{{ contractValidityInvalidHint }}</div>
					}
				</div>
				} @if (showPartnerUploadActionButton) {
				<button
					mat-flat-button
					type="button"
					class="mat-primary upload-button"
					[disabled]="isBlocked || isUploading || !hasCredentials || hasDocumentBlockingUpload || hasFrozenReviewedDocument || (!hasQueuedFile && !(isMultiPageEnabled && hasBufferedMultiPageFiles)) || isExpiryMissing || isPartnerUploadBlockedByContractStart"
					(click)="triggerUpload()">
					@if (isUploading) {
					<span>Wird hochgeladen...</span>
					} @else { @if (isMultiPageEnabled && hasBufferedMultiPageFiles && !hasQueuedFile) {
					@if (showExpiryInput) { @if (deferUpload) {
					<span>Datum bestätigen und vormerken</span>
					} @else {
					<span>Datum bestätigen und hochladen</span>
					} } @else {
					<span>Fertigstellen</span>
					}
				} @else { @if (deferUpload) {
					@if (showExpiryInput) {
					<span>Datum bestätigen und vormerken</span>
					} @else {
					<span>Zum Speichern vormerken</span>
					}
				} @else { @if (showTextActionButtons) {
					<span>Dokument hochladen</span>
					} @else {
					<span>Upload</span>
					} } } }
				</button>
				}
			</div>
			} } } @if (visibleErrorMessage; as message) {
			<div class="upload-error">{{ message }}</div>
			} @if (revalidationMessage) {
			<div class="upload-warning">{{ revalidationMessage }}</div>
			} @if (visibleSuccessMessage; as message) {
			<div class="upload-success">{{ message }}</div>
			}
		</div>

		@if (hasLayoutFloatingLabels && lorenzFormControl.hasLabel()) {
		<label
			class="floating-label"
			[innerHTML]="(lorenzFormControl.getLabel() | translate) + lorenzFormControl.getRequiredAsterisk()">
		</label>
		}

		<lib-form-validity-dot [control]="lorenzFormControl" />
	</div>

	@if (showErrorMessages) {
	<div class="error">{{ lorenzFormControl.getErrors() | translate }}</div>
	}
</div>

<ng-template
	#documentCardTemplate
	let-doc
	let-expired="expired"
	let-showDetails="showDetails">
	<div
		class="document-item"
		[ngClass]="{
			expired: expired,
			'contract-start-invalid': !expired && isInvalidForContractStart(doc)
		}">
		<div class="document-info">
			<div class="document-title-row">
				<div class="document-name">{{ formatDisplayFileName(doc.original_name) }}</div>
				<div class="document-badges">
					@if (expired) {
					<span class="document-badge document-badge-danger">Abgelaufen</span>
					} @else { @if (isPersonDocumentsApp && isLatestDocument(doc)) {
					<span class="document-badge document-badge-info">Aktuell</span>
					} @if (isSelectedForContract(doc)) {
					<span class="document-badge document-badge-info">Für diesen Vertrag verwendet</span>
					} @if (isPendingPartnerUpload(doc)) {
					<span class="document-badge document-badge-warning">Ersatz hochgeladen</span>
					} @if (isInvalidForContractStart(doc)) {
					<span class="document-badge document-badge-warning">Ungültig für Vertragsstart</span>
					} @if (canReviewDocuments) {
					<span
						class="review-status-pill"
						[ngClass]="getReviewStatusClass(doc)">
						{{ getReviewStatusLabel(doc) }}
					</span>
					} }
				</div>
			</div>
			<div class="document-meta-row">
				@if (showExpiryMeta && doc.expires_at) {
				<span class="document-meta">
					@if (expired) { Abgelaufen am {{ formatDateForDisplay(doc.expires_at) }} } @else { Gültig bis {{ formatDateForDisplay(doc.expires_at) }}
					}
				</span>
				} @if (!expired && isPersonDocumentsApp) { @if (getUploadedAtDisplay(doc); as uploadedAt) {
				<span class="document-meta">Hochgeladen {{ uploadedAt }}</span>
				} } @if (expired && doc.expires_cleanup_at) {
				<span class="document-meta">Geplante Löschung ab {{ formatDateForDisplay(doc.expires_cleanup_at) }}</span>
				} @if (showDownloadedMeta && doc.downloaded_at) {
				<span class="document-meta">Heruntergeladen {{ doc.downloaded_at }}</span>
				}
			</div>
		</div>

		<ng-container *ngTemplateOutlet="documentActionsTemplate; context: { $implicit: doc }"></ng-container>

		@if (showDetails) {
		<div class="document-details">
			@if (isInvalidForContractStart(doc)) {
			<div class="document-status-panel warning">
				{{ getContractStartStatusSummary(doc) }}
			</div>
			} @if (isPersonDocumentsApp && hasInvalidOpenContracts(doc)) {
			<ng-container *ngTemplateOutlet="documentContractsTemplate; context: { $implicit: doc }"></ng-container>
			} @if (canReviewDocuments && !isReviewGateOpen(doc) && !isDocumentRequested(doc)) {
			<div class="document-meta document-meta-subtle">Zum Prüfen zuerst Vorschau oder Download öffnen.</div>
			} @if (canReviewDocuments && doc.requested_reason) {
			<div class="document-meta">Anfragegrund: {{ doc.requested_reason }}</div>
			} @if (isEditingDocumentExpiry(doc)) {
			<div class="expiry-edit-row">
				<label class="expiry-label">Ablaufdatum</label>
				<input
					class="expiry-control"
					type="date"
					[formControl]="expiryEditControl"
					[attr.disabled]="isSavingExpiry ? true : null" />
				<div class="expiry-edit-actions">
					<button
						mat-flat-button
						type="button"
						class="mat-primary document-action-button"
						[disabled]="isSavingExpiry || !expiryEditControl.value"
						(click)="saveDocumentExpiry(doc)">
						<span>Speichern</span>
					</button>
					<button
						mat-flat-button
						type="button"
						class="mat-secondary document-action-button"
						[disabled]="isSavingExpiry"
						(click)="cancelDocumentExpiryEdit()">
						<span>Abbrechen</span>
					</button>
				</div>
			</div>
			}
		</div>
		}
	</div>
</ng-template>

<ng-template
	#documentActionsTemplate
	let-doc>
	<div
		class="document-actions"
		[ngClass]="{
			'dense-layout': canReviewDocuments || isBackendContractEditApp,
			'icon-actions': !showTextActionButtons
		}">
		<div class="action-group action-group-file">
			<div class="action-group-label">Datei</div>
			@if (allowPreview) { @if (showTextActionButtons) {
			<button
				mat-flat-button
				class="mat-preview document-action-button"
				type="button"
				[disabled]="!canPreviewDocument(doc)"
				(click)="previewDocument(doc)">
				<span>Vorschau</span>
			</button>
			} @else {
			<button
				mat-flat-button
				class="mat-preview document-action-icon-button"
				type="button"
				matTooltip="Vorschau"
				aria-label="Vorschau"
				[disabled]="!canPreviewDocument(doc)"
				(click)="previewDocument(doc)">
				<mat-icon>visibility</mat-icon>
			</button>
			} } @if (allowDownload) { @if (showTextActionButtons) {
			<button
				mat-flat-button
				class="mat-primary document-action-button"
				type="button"
				[disabled]="!canDownloadDocument(doc)"
				(click)="downloadDocument(doc)">
				<span>Herunterladen</span>
			</button>
			} @else {
			<button
				mat-flat-button
				class="mat-primary document-action-icon-button"
				type="button"
				matTooltip="Download"
				aria-label="Download"
				[disabled]="!canDownloadDocument(doc)"
				(click)="downloadDocument(doc)">
				<mat-icon>download</mat-icon>
			</button>
			} } @if (allowDelete) { @if (showTextActionButtons) {
			<button
				mat-flat-button
				class="mat-development document-action-button"
				type="button"
				[disabled]="!canDeleteDocument(doc)"
				(click)="deleteDocument(doc.id, doc)">
				<span>Löschen</span>
			</button>
			} @else {
			<button
				mat-flat-button
				class="mat-development document-action-icon-button"
				type="button"
				matTooltip="Löschen"
				aria-label="Löschen"
				[disabled]="!canDeleteDocument(doc)"
				(click)="deleteDocument(doc.id, doc)">
				<mat-icon>delete</mat-icon>
			</button>
			} }
		</div>

		@if (canReviewDocuments) {
		<div class="action-group action-group-review">
			<div class="action-group-label">Prüfung</div>
			<button
				mat-flat-button
				class="mat-success document-action-icon-button"
				type="button"
				matTooltip="Als geprüft markieren"
				aria-label="Als geprüft markieren"
				[disabled]="!canMarkReviewStatus(doc)"
				(click)="markDocumentAsReviewed(doc)">
				<mat-icon>verified</mat-icon>
			</button>
			<button
				mat-flat-button
				class="mat-secondary document-action-icon-button"
				type="button"
				[matTooltip]="isBackendContractEditApp && isPendingPartnerUpload(doc) ? 'Ersatz im Vertrag übernehmen' : 'Dokument annehmen'"
				[attr.aria-label]="isBackendContractEditApp && isPendingPartnerUpload(doc) ? 'Ersatz im Vertrag übernehmen' : 'Dokument annehmen'"
				[disabled]="!canAcceptDocument(doc)"
				(click)="acceptDocument(doc)">
				<mat-icon>check</mat-icon>
			</button>
			<button
				mat-flat-button
				class="mat-development document-action-icon-button"
				type="button"
				matTooltip="Dokument ablehnen"
				aria-label="Dokument ablehnen"
				[disabled]="!canRejectDocument(doc)"
				(click)="rejectDocument(doc)">
				<mat-icon>close</mat-icon>
			</button>
		</div>
		} @if (isBackendManagementApp && showExpiryMeta) {
		<div class="action-group action-group-replacement">
			<div class="action-group-label">Ablaufdatum</div>
			<button
				mat-flat-button
				class="mat-secondary document-action-icon-button"
				type="button"
				matTooltip="Ablaufdatum bearbeiten"
				aria-label="Ablaufdatum bearbeiten"
				[disabled]="!canEditDocumentExpiry(doc) || isSavingExpiry"
				(click)="startDocumentExpiryEdit(doc)">
				<mat-icon>edit</mat-icon>
			</button>
		</div>
		} @if (isBackendDocumentsApp) {
		<div class="action-group action-group-contract">
			<div class="action-group-label">Kategorie</div>
			<button
				mat-flat-button
				class="mat-secondary document-action-icon-button"
				type="button"
				matTooltip="Als aktuelle Datei festlegen"
				aria-label="Als aktuelle Datei festlegen"
				[disabled]="!canSetCurrentDocument(doc)"
				(click)="setCurrentDocument(doc)">
				<mat-icon>star</mat-icon>
			</button>
		</div>
		}
	</div>
</ng-template>

<ng-template
	#documentContractsTemplate
	let-doc>
	<div class="document-status-panel subtle-warning">
		<div class="contracts-panel">
			<div class="contracts-panel-title">Betroffene Verträge</div>
			<div class="contracts-table-scroll">
				<table class="contracts-table">
					<thead>
						<tr>
							<th>Vertrag</th>
							<th>Zeitraum</th>
						</tr>
					</thead>
					<tbody>
						@for (contract of getInvalidContracts(doc); track contract.contract_id + '-' + contract.contract_period_display) {
						<tr>
							<td>
								@if (contract.contract_link) {
								<a
									class="contract-link"
									[href]="contract.contract_link"
									>{{ contract.label }}</a
								>
								} @else {
								<span>{{ contract.label }}</span>
								}
							</td>
							<td>{{ contract.contract_period_display }}</td>
						</tr>
						}
					</tbody>
				</table>
			</div>
		</div>
	</div>
</ng-template>

}
